// src/core/coralogix-naming.ts
var TELEMETRY_COMPONENTS = {
  rotagen: "Templates.Rotagen",
  backend: "Templates.Backend",
  templateBuilderEvo: "Templates.TemplateBuilderEvo",
  admin: "Templates.Admin"
};
function coralogixEnvironmentFrom(deployEnvironment) {
  switch (deployEnvironment) {
    case "development":
      return "Dev";
    case "uat":
      return "UAT";
    case "production":
      return "Production";
    default:
      return void 0;
  }
}
function openTelemetryNamingFor(params) {
  return {
    applicationName: `Rotaready.${params.environment}`,
    subsystemName: params.component,
    serviceName: params.component
  };
}
function rumApplicationNameFor(component) {
  return `Rotaready.${component}`;
}

export {
  TELEMETRY_COMPONENTS,
  coralogixEnvironmentFrom,
  openTelemetryNamingFor,
  rumApplicationNameFor
};
//# sourceMappingURL=chunk-GDUMMQAD.js.map